/*
 * @Author: Raeesaa Metkari
 * @Date: 2020-07-24 15:23:36
 * @Last Modified by: Raeesaa Metkari
 * @Last Modified time: 2020-07-29 19:22:07
 */
import forEach from 'lodash/forEach'
import includes from 'lodash/includes'
import orderBy from 'lodash/orderBy'
import { config } from '@config'
import { VIPProduct } from '@modules/common/models/interfaces/VIPProduct'
import { convertToCurrencyLocaleString } from '@services/assortmentService'
import { VIPBuyingSessionProduct } from './productService'
import { getEnumValue } from '@utils/get-enum-value'
import { DefaultConfig } from '@constants'

class WholesalePriceService {
  getUniqueArticlesForBuyingSessionProducts = (
    buyingSessionProducts: Array<VIPBuyingSessionProduct>
  ) => {
    let uniqueArticles = []
    forEach(buyingSessionProducts, (bsp: VIPBuyingSessionProduct) => {
      let seasonalProduct: VIPProduct = bsp?.Original
      let article = seasonalProduct?.Style?.Article
      if (!includes(uniqueArticles, article)) {
        uniqueArticles.push(article)
      }
    })

    return uniqueArticles
  }

  getVariableForFetchingPrices = (retailPriceGroup, wholesalePriceGroup) => {
    return {
      retailPriceGroup: getEnumValue(
        retailPriceGroup
          ? retailPriceGroup
          : config.centralRetailPriceListGroup ||
              DefaultConfig.CENTRAL_RETAIL_PRICELIST_GROUP
      ),
      // for prices in zone/cleint assortment try to get price type from client
      retailPriceType: getEnumValue(
        config.centralRetailPriceListType || DefaultConfig.CENTRAL_RETAIL_PRICELIST_TYPE
      ),
      suggestedRetailPriceGroup: getEnumValue(
        retailPriceGroup
          ? retailPriceGroup
          : config.centralSRPPriceListGroup || DefaultConfig.CENTRAL_SRP_PRICELIST_GROUP
      ),
      suggestedRetailPriceType: getEnumValue(
        config.centralSRPPriceListType || DefaultConfig.CENTRAL_SRP_PRICELIST_TYPE
      ),
      wholesalePriceGroup: getEnumValue(
        wholesalePriceGroup
          ? wholesalePriceGroup
          : config.centralWholesalePriceListGroup ||
              DefaultConfig.CENTRAL_WHL_PRICELIST_GROUP
      ),
      wholesalePriceType: getEnumValue(
        config.centralWholesalePriceListType || DefaultConfig.CENTRAL_WHL_PRICELIST_TYPE
      ),
      ...(getEnumValue(config.centralCustomPriceGroup) && {
        srpCustomPriceGroup: getEnumValue(config.centralCustomPriceGroup),
        srpCustomPriceType: getEnumValue(config.centralCustomPriceType)
      })
    }
  }

  sortPriceListValuesByExtId = priceListValues => {
    return orderBy(priceListValues || [], priceValue => priceValue?.VIPExternalId, 'desc')
  }

  getFormattedPrice = (value, currency) => {
    return value !== null && value !== undefined
      ? convertToCurrencyLocaleString(currency, value)
      : 'NA'
  }
}

export const wholesalePriceService = new WholesalePriceService()
